import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import ESSearchWordSps from './ESSearchWordSps'
import TEshopDM from './TEshopDM'
import TArticleDM from './TArticleDM'

export default class TEshopSearchWordDM extends Data {
	public static className = 'TEshopSearchWordDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => ESSearchWordSps)
	WordId?: ESSearchWordSps
	@Type(() => TEshopDM)
	ShopRID?: TEshopDM
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}